
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Globe, Download } from 'lucide-react';
import { WebsiteOption, WebsiteOptionConfig } from './types';

interface WebsiteSelectorProps {
  selectedWebsite: WebsiteOption;
  onWebsiteChange: (website: WebsiteOption) => void;
}

const websiteOptions: WebsiteOptionConfig[] = [
  { value: 'all', label: 'Tous les sites', icon: Globe },
  { value: 'leboncoin', label: 'LeBonCoin uniquement', icon: Download },
  { value: 'europe-camions', label: 'Europe-Camions uniquement', icon: Download }
];

export const WebsiteSelector = ({ selectedWebsite, onWebsiteChange }: WebsiteSelectorProps) => {
  return (
    <div>
      <label className="text-sm font-medium text-gray-700 mb-2 block">
        Site à importer
      </label>
      <Select value={selectedWebsite} onValueChange={onWebsiteChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Choisir un site" />
        </SelectTrigger>
        <SelectContent>
          {websiteOptions.map((option) => {
            const Icon = option.icon;
            return (
              <SelectItem key={option.value} value={option.value}>
                <div className="flex items-center space-x-2">
                  <Icon className="h-4 w-4" />
                  <span>{option.label}</span>
                </div>
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
};
